import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro';
import { MutableRefObject } from 'react';

const datagridCellFocusEvent =
  (apiRef: MutableRefObject<GridApiPro>) =>
  (event: React.FocusEvent<HTMLDivElement>) => {
    const cellElement = event.currentTarget;
    const field = cellElement.getAttribute('data-field');
    const id = parseInt(
      cellElement.parentElement?.getAttribute('data-id') ?? '',
      10
    );

    // apiRefが存在し、フィールドがチェックボックスやアクションでない場合のみ
    if (
      apiRef.current &&
      field &&
      field !== '__check__' &&
      field !== 'actions'
    ) {
      try {
        // 現在のセルモードを取得
        const cellMode = apiRef.current.getCellMode(id, field);

        // セルが表示モード（'view'）の場合のみ編集モードに切り替え
        if (cellMode === 'view') {
          apiRef.current.startCellEditMode({ id, field });
        }
      } catch (error) {
        console.error('セルモード切替エラー:', error);
      }
    }
  };

export default datagridCellFocusEvent;
